@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.action-menu-wrapper {
  .danger {
    color: @settings-page--automation-rules-grid-action-menu--error--text-color;
  }
}

.actions-dropdown {
  background-color: inherit;
  border: none;
  height: 100%;
}

.icon-wrapper {
  color: @settings-page--automation-rules-grid-action-icon--text-color;
  cursor: pointer;

  &:hover {
    color: @settings-page--automation-rules-grid-icon--hover--text-color;
  }

  svg {
    width: 16px;
  }
}

.icon-open {
  .icon-wrapper {
    color: @settings-page--automation-rules-grid-icon-open--text-color;
    cursor: pointer;

    &:hover {
      color: @settings-page--automation-rules-grid-icon--hover--text-color;
    }
  }
}
